/* eslint-disable no-throw-literal */
import {
  SHOP_ORDER_DETAIL_GET,
  SHOP_ORDER_DETAIL_UPDATE
} from './mutation-types'

export default {
  actions: {
    async [SHOP_ORDER_DETAIL_GET] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/shop_order_details/get_by_shop_order_id', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDER_DETAIL_UPDATE] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiPatch', {url: `/stock/shop_order_details/${params.id}`, data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-order-details.js